<template>
	<page style="background: #fff;">
		<div class="head">
			<h5>{{productName || '-'}}</h5>
			<p>背贴码：{{codeInfo.produce_unique_code || '-'}}</p>
		</div>
		
		<dl v-if="peijianImage || bannerList.length" class="assets">
			<dt class="flex-center">轮播图</dt>
			<dd class="flex-wrap">
				<div v-if="peijianImage" class="image flex-center" @click="$preview({src: peijianImage})">
					<img :src="peijianImage" alt="">
					<div class="image-tag flex-center">配件</div>
				</div>
				<div v-for="(item, i) in bannerList" :key="i" class="image flex-center" @click="$preview({src: bannerList, index: i})">
					<img :src="item" alt="">
				</div>
			</dd>
		</dl>
		<dl v-if="liangjiList.length" class="assets">
			<dt class="flex-center">B端靓机轮播图</dt>
			<dd class="flex-wrap">
				<div v-for="(item, i) in liangjiList" :key="i" class="image flex-center" @click="$preview({src: liangjiList, index: i})">
					<img :src="item" alt="">
				</div>
			</dd>
		</dl>
		<dl v-if="xianyuList.length" class="assets">
			<dt class="flex-center">闲鱼严选渠道轮播图</dt>
			<dd class="flex-wrap">
				<div v-for="(item, i) in xianyuList" :key="i" class="image flex-center" @click="$preview({src: xianyuList, index: i})">
					<img :src="item" alt="">
				</div>
			</dd>
		</dl>
		<dl v-if="jingdongList.length" class="assets">
			<dt class="flex-center">京东首图</dt>
			<dd class="flex-wrap">
				<div v-for="(item, i) in jingdongList" :key="i" class="image flex-center" @click="$preview({src: jingdongList, index: i})">
					<img :src="item" alt="">
				</div>
			</dd>
		</dl>
		<dl v-if="flawList.length" class="assets">
			<dt class="flex-center">瑕疵图</dt>
			<dd class="flex-wrap">
				<div v-for="(item, i) in flawList" :key="i" @click="$preview({src: flawList.map(item => item.image_url), index: i})">
					<div class="image flex-center">
						<img :src="item.image_url" alt="">
					</div>
					<p class="image-text">{{item.parent_name}}</p>
				</div>
			</dd>
		</dl>

		<cut-line></cut-line>
		
		<ul class="tab flex-center">
			<li :class="{'z-crt': currentReport == 1}" @click="currentReport = 1">B端报告</li>
			<li :class="{'z-crt': currentReport == 2}" @click="currentReport = 2">C端报告</li>
		</ul>

		<div v-if="baseInfoFields.length" style="margin-bottom: .3rem;">
			<c-title style="margin: 0 .3rem;">基础信息</c-title>
			<c-detail style="padding: 0 .3rem;">
				<c-detail-item v-for="(item, j) in baseInfoFields" :key="j" :label="item.label">{{item.value}}</c-detail-item>
			</c-detail>
		</div>
		<div v-for="(group, i) in currentReportData" :key="i" style="margin-bottom: .3rem;">
			<c-title style="margin: 0 .3rem;">{{group.group_name}}</c-title>
			<c-detail style="padding: 0 .3rem;">
				<c-detail-item v-for="(item, j) in group.items" :key="j" :label="item.parent_name">{{item.value}}</c-detail-item>
			</c-detail>
		</div>
		<c-empty v-if="currentReportData === false" message="暂无质检报告"></c-empty>
	</page>
</template>

<script>
	export default {
		props: {
			code: String
		},

		data() {
			return {
				codeInfo: {},
				peijianImage: '',
				bannerList: [],
				liangjiList: [],
				xianyuList: [],
				jingdongList: [],
				flawList: [],

				reportData: {},
				currentReport: 1
			}
		},

		computed: {
			productName() {
				return [this.codeInfo.brand_name, this.codeInfo.spu_model_name, this.codeInfo.color_name, this.codeInfo.memory_name].filter(item => item).join(' ');
			},

			baseInfoFields() {
				var custom = this.codeInfo[this.currentReport == 1 ? 'custom_fields_value_json' : 'c_custom_fields_value_json'] || {};
				var list = custom.attribute || [];
				return list.map(item => ({label: item.attribute_name, value: item.attribute_value}));
			},

			currentReportData() {
				return this.reportData[this.currentReport];
			}
		},

		mounted() {
			this.request({
				url: '/productCode/queryByCode',
				data: {
					produce_unique_code: this.code
				},
				success: data => {
					this.codeInfo = data;
					this.loadImage();
					this.loadReport(1);
					this.loadReport(2);
				}
			});
		},
		
		methods: {
			loadImage() {
				this.request({
					url: '/quality/image/list',
					data: {
						product_code_id: this.codeInfo.id
					},
					success: data => {
						this.peijianImage = data.find(item => item.image_type == 5 && item.image_url) ? data.find(item => item.image_type == 5 && item.image_url).image_url : '';
						this.bannerList = data.filter(item => item.image_type == 1 && item.image_url).map(item => item.image_url);
						this.liangjiList = data.filter(item => item.image_type == 6 && item.image_url).map(item => item.image_url);
						this.xianyuList = data.filter(item => item.image_type == 3 && item.image_url).map(item => item.image_url);
						this.jingdongList = data.filter(item => item.image_type == 4 && item.image_url).map(item => item.image_url);
						this.flawList = data.filter(item => item.image_type == 2 && item.image_url);
					}
				});
			},

			loadReport(type) {
				this.request({
					url: '/quality/report/queryByProduct',
					data: {
						product_code_id: this.codeInfo.id,
						report_type: type
					},
					success: data => {
						if (data.report) {
							let info = JSON.parse(data.report.result_json).groups;
							info.forEach(group => {
								group.items.forEach(item => {
									let selected = item.children.find(option => option.selected);
									item.value = selected ? selected.release_name : '';
								});
							});
							this.$set(this.reportData, type, info);
						} else {
							this.$set(this.reportData, type, false);
						}
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.head {
		padding: .26rem;
		margin-bottom: .2rem;
		font-size: .26rem;
		text-align: center;
		color: #666;
		background: #EFF2FF;

		h5 {
			margin-bottom: .2rem;
			font-size: .32rem;
			color: #000;
		}
	}

	.assets {
		margin: 0 .24rem .3rem;

		dt {
			gap: .1rem;
			height: 1.1rem;
			font-size: .3rem;
			color: var(--color-main);

			&:before, &:after {
				content: '';
				flex-grow: 1;
				width: 0;
				height: .02rem;
				background: #eee;
			}
		}

		dd {
			gap: .2rem;

			.image {
				position: relative;
				box-sizing: border-box;
				width: 1.6rem;
				height: 1.6rem;
				background: #F5F5F5;

				&-tag {
					position: absolute;
					left: 0;
					bottom: 0;
					width: .48rem;
					height: .48rem;
					border-top-right-radius: .12rem;
					padding: 0 .12rem;
					font-size: .24rem;
					color: #fff;
					background: rgba(0,0,0,.7);
				}

				&-text {
					line-height: .64rem;
					font-size: .26rem;
					text-align: center;
					color: #666;
				}
			}
		}
	}

	.tab {
		gap: .26rem;
		padding: .3rem 0;

		li {
			border-radius: .32rem;
			padding: 0 .45rem;
			line-height: .64rem;
			font-size: .3rem;
			color: #444;
			background: #F5F5F5;

			&.z-crt {
				color: #fff;
				background: var(--color-main);
			}
		}
	}
</style>